import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { turnIntoList, unwrapList } from 'common/Prose/utils'
import { computed } from 'mobx'
import { schema } from 'prose-core'
import { EditorView } from 'prosemirror-view'
import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'

export function useBulletListToggle(view: EditorView): ButtonHook {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!

  const selectionHasList = computed(() => almanacState.activeNodes.has(schema.nodes.unordered_list)).get()
  const selectionInList = computed(() => almanacState.containingNodeTypes.has(schema.nodes.unordered_list)).get()

  const handleClick = selectionInList
    ? unwrapList(view, schema.nodes.unordered_list)
    : turnIntoList(view, schema.nodes.unordered_list)

  return { active: selectionHasList, handleClick }
}
